<template>
  <div>
    <!-- 提现表单 -->
    <Modal v-model="visible" title="确认提现" width="1000" class="my-modal">
      <loading :isShow="loading" />
      <Form ref="myForm" class="page-form less" :model="formData" :label-width="120">
        <div class="form-title">银行账户信息</div>
        <FormItem label="户主名称" prop="userName" :rules="$units.formRule.required('请输入户主名称')">
          <Input v-model="formData.userName" disabled />
        </FormItem>
        <FormItem label="开户银行" prop="bank" :rules="$units.formRule.required('请选择开户银行')">
          <Select v-model="formData.bank" disabled filterable>
            <Option :value="item.value" v-for="(item, i) in bankArr" :key="i">{{ item.txt }}</Option>
          </Select>
        </FormItem>
        <FormItem label="开户支行" prop="accountOpenBranch" :rules="$units.formRule.required('请输入开户支行')">
          <Input v-model="formData.accountOpenBranch" disabled clearable />
        </FormItem>
        <FormItem label="账号类型" prop="type" :rules="$units.formRule.required('请选择账号类型')">
          <Select v-model="formData.type" disabled>
            <Option value="1">对公</Option>
            <Option value="2">对私</Option>
          </Select>
        </FormItem>
        <FormItem label="银行账号" prop="cardNo" :rules="$units.formRule.required('请输入银行账号')">
          <Input v-model="formData.cardNo" disabled clearable />
        </FormItem>
        <div class="form-title">发票邮寄信息</div>
        <FormItem label="快递公司" prop="deliveryCompany" :rules="$units.formRule.required('请输入快递公司')">
          <Input v-model="formData.deliveryCompany" placeholder="请输入快递公司" clearable />
        </FormItem>
        <FormItem label="运单号" prop="deliveryId" :rules="$units.formRule.required('请输入运单号')">
          <Input v-model="formData.deliveryId" placeholder="请输入运单号" clearable />
        </FormItem>
        <FormItem label="发票、结算函明细盖章图片/PDF" prop="detail" :rules="$units.formRule.arrRequired('请上传')" class="full">
          <uploadNew v-model="formData.detail" :muti="true" @change="imgUpload" fileType="pdf,img" />
        </FormItem>
      </Form>
      <div class="tipMsg">
        <p>注意事项</p>
        <p>1、开具发票：商户请根据申请金额开具服务发票，可以开多张发票，发票总金额要和提现金额一致;</p>
        <p>2、发票填写：请根据开票信息，确保发票抬头、发票项目、发票金额准确无误，否则我司将不予付款;</p>
        <p>3、我司将在收到发票以后进行转账;<a style="color: #21a1fe" @click="$refs.invoiceDetailModal.open()">查看开票信息</a></p>
        <p>4、发票盖发票专用章，结算函与结算明细表盖公章，二者都需要邮寄。</p>
      </div>
      <div slot="footer">
        <Button type="primary" ghost @click="visible = false">取消</Button>
        <Button type="primary" @click="submit">确定</Button>
      </div>
    </Modal>
    <!-- 查看开票信息 -->
    <invoiceDetailModal ref="invoiceDetailModal"></invoiceDetailModal>
  </div>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import invoiceDetailModal from './invoiceDetailModal';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    uploadNew,
    invoiceDetailModal
  },
  data() {
    return {
      visible: false,
      loading: false,
      rowItem: {},
      bankArr: [],
      formData: {},
    };
  },
  methods: {
    async open(item) {
      this.visible = true;
      this.rowItem = item;
      this.loading = true;
      await this.getBankArr();
      await this.getBankInfo();
      this.clearValidate();
      this.loading = false;
    },
    // 获取银行信息
    getBankInfo() {
      return this.$http({
        url: '/buz/merchantWithdrawLog/read/info',
        type: 'GET'
      }).then(res => {
        const data = res.data;
        delete data.idNo;
        data.detail = [];
        this.formData = data;
      });
    },
    // 获取银行下拉数据
    getBankArr() {
      return this.$http({
        type: 'post',
        url: '/system/dic/read/dicList',
        data: {
          code: 'BANK_TYPE'
        }
      }).then(res => {
        this.bankArr = res.data;
      });
    },
    submit() {
      this.$refs.myForm.validate(valid => {
        if (!valid) {
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.detail = formData.detail.map(item => item.path);
        formData.id = this.rowItem.id;
        this.$http({
          url: '/buz/merchantWithdrawLog/add',
          type: 'POST',
          data: formData
        })
          .then(res => {
            this.$notice.success('提交成功');
            this.$emit('reload');
            this.visible = false;
          })
          .finally(() => {
            window.setTimeout(() => {
              this.loading = false;
            }, 500);
          });
      });
    },
    imgUpload() {
      this.$refs.myForm.validateField('detail');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>